var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#005EB8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 27H20.75V17H18.25V27ZM23.25 27H25.75V17H23.25V27ZM22 34.5C20.2708 34.5 18.6458 34.1719 17.125 33.5156C15.6042 32.8594 14.2812 31.9688 13.1562 30.8438C12.0312 29.7188 11.1406 28.3958 10.4844 26.875C9.82812 25.3542 9.5 23.7292 9.5 22C9.5 20.2708 9.82812 18.6458 10.4844 17.125C11.1406 15.6042 12.0312 14.2812 13.1562 13.1562C14.2812 12.0312 15.6042 11.1406 17.125 10.4844C18.6458 9.82812 20.2708 9.5 22 9.5C23.7292 9.5 25.3542 9.82812 26.875 10.4844C28.3958 11.1406 29.7188 12.0312 30.8438 13.1562C31.9688 14.2812 32.8594 15.6042 33.5156 17.125C34.1719 18.6458 34.5 20.2708 34.5 22C34.5 23.7292 34.1719 25.3542 33.5156 26.875C32.8594 28.3958 31.9688 29.7188 30.8438 30.8438C29.7188 31.9688 28.3958 32.8594 26.875 33.5156C25.3542 34.1719 23.7292 34.5 22 34.5ZM22 32C24.7917 32 27.1562 31.0312 29.0938 29.0938C31.0312 27.1562 32 24.7917 32 22C32 19.2083 31.0312 16.8438 29.0938 14.9062C27.1562 12.9688 24.7917 12 22 12C19.2083 12 16.8438 12.9688 14.9062 14.9062C12.9688 16.8438 12 19.2083 12 22C12 24.7917 12.9688 27.1562 14.9062 29.0938C16.8438 31.0312 19.2083 32 22 32Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconButton);
export default __webpack_public_path__ + "static/media/IconButton.dff9d3edeb5d4e8ffcedd2ce87d80bce.svg";
export { ForwardRef as ReactComponent };